export default __webpack_public_path__ + "static/media/arch_green.5f61bb89.svg";